import { render, staticRenderFns } from "./referralrewardrecord.vue?vue&type=template&id=4658737b&scoped=true"
import script from "./referralrewardrecord.vue?vue&type=script&lang=js"
export * from "./referralrewardrecord.vue?vue&type=script&lang=js"
import style0 from "./referralrewardrecord.vue?vue&type=style&index=0&id=4658737b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4658737b",
  null
  
)

export default component.exports